(function () {
	'use strict';
	angular
		.module('app.setup')
		.directive('pipelineStepDownload', pipelineStepDownload);

	function pipelineStepDownload() {
		return {
			restrict: 'E',
			templateUrl: '/application/f/setup/pipeline-step-download.html',
			scope: {
				href: '@',
				factoryndx: '@',
				datatype: '@',
				requestdate: '@',
				onfail: '&'
			},
			controller: pipelineStepDownloadCtrl,
			controllerAs: 'vm'
		};
	}
	
	pipelineStepDownloadCtrl.$inject = ['$rootScope', '$scope', '$uibModal', '$http', 'dataPipelineService'];
	function pipelineStepDownloadCtrl($rootScope, $scope, $uibModal, $http, dataPipelineService) {
		var vm = this;
		vm.href = $scope.href;
		vm.requestDate = $scope.requestdate;
		vm.onDownloadFail = $scope.onfail;
		vm.s3ExpirationInDays = 30;
		vm.icon = 'download';
		vm.dataType = $scope.datatype;

		if (vm.dataType === 'leansync') {
			vm.title = 'Download data';
		} else if (vm.dataType === 'leanload') {
			vm.title = 'Download LeanLoad data';
		} else if (vm.dataType === 'site') {
			vm.title = 'Download site data';
		} else if (vm.dataType === 'sitePostProcessed') {
			vm.title = 'Download post-processed site data';
		} else if (vm.dataType === 'global') {
			vm.title = 'Download global data';
			vm.icon = 'globe';
		} else if (vm.dataType === 'leandna connect') {
			vm.title = 'Download log file';
			vm.s3ExpirationInDays = 180;
		}

		vm.downloadData = function() {
			$http.get(dataPipelineService.getStatusPathFromDownloadPath(vm.href))
				.then(function(response) {
					var msg = response.data;
					if(msg && msg.status && msg.status === 'RESTORE_NOT_INITIATED') {
						vm.restoreData(msg.status);
						return;
					} else if (msg && msg.status && msg.status === 'RESTORE_IN_PROGRESS') {
						vm.restoreData(msg.status);
						return;
					} else if (msg && msg.status && msg.status.startsWith('ATHENA')) {
						vm.pullData(msg);
						return;
					}
					jQuery.fileDownload(vm.href);
				})
				.catch(function(error) {
					vm.onDownloadFail({'dataType': vm.dataType});
				});
		};

		vm.restoreData = function(status) {
			var restoreScope = $scope.$new();
			restoreScope.status = status;

			var instance = $uibModal.open({
				scope: restoreScope,
				templateUrl: '/application/f/setup/supplyChain/restore-archived-file-modal.html'
			});

			restoreScope.closeDialog = function() {
				instance.close();
				restoreScope.$destroy();
			};

			restoreScope.restoreFile = function() {
				$http.get(dataPipelineService.getRestorePathFromDownloadPath(vm.href))
					.then(function() {
						restoreScope.status = 'RESTORE_IN_PROGRESS';
					})
					.catch(function() {
						restoreScope.status = 'RESTORE_REQUEST_FAILED';
					});
			};
		};

		vm.pullData = function(msg) {
			var pullScope = $scope.$new();
			pullScope.status = msg.status;
			pullScope.attempts = msg.attempts;
			pullScope.retryable = (msg.status === 'ATHENA_PULL_FAILED' || msg.status === 'ATHENA_PULL_TIMEOUT') && (msg.attempts < 3);

			var instance = $uibModal.open({
				scope: pullScope,
				templateUrl: '/application/f/setup/supplyChain/restore-archived-file-modal.html'
			});

			pullScope.closeDialog = function() {
				instance.close();
				pullScope.$destroy();
			};

			pullScope.pullAthena = function() {
				$http.get(dataPipelineService.getPullPathFromDownloadPath(vm.href))
					.then(function() {
						pullScope.status = 'ATHENA_PULL_IN_PROGRESS';
					})
					.catch(function() {
						pullScope.status = 'ATHENA_PULL_FAILED';
					});
			};
		};
	};
})();
